import './PreChargebackEvaluation.css';
import { useSelector } from 'react-redux';
import FoundTxnWithUtr from './FoundTxnWithUtr';
import GetInvoiceNo from './GetInvoiceNo';
import ChargebackAlreadyExist from './ChargebackAlreadyExist';
import TransactionCheck from './TransactionCheck';

const PreChargebackEvaluation = () => {
    let token = useSelector((store) => store.userReducer.token);

    return (
        <div className="cbe-container">
            <h3 className="cbe-title">Pre-Chargeback Evaluation</h3>
            <FoundTxnWithUtr token={token} />
            <h3 className="cbe-title">Transaction Invoice Number</h3>
            <GetInvoiceNo token={token} />
            <h3 className="cbe-title">Chargeback Already Exists</h3>
            <ChargebackAlreadyExist token={token} />
            <h3 className="cbe-title">Transaction Reconciliation Tool</h3>
            <TransactionCheck token={token} />
        </div>
    );
};

export default PreChargebackEvaluation;
